import  {ReactNode } from "react";
import Navbar from "../nav/NavBar";
import NavControls from "../nav/NavControls";

export default function OpenRoute({ children } : {children : ReactNode}) {
  return (
      <>
        <Navbar navComponent={<NavControls/>}/>
        {children}
      </>
    );
}